import { TimelineLite, TweenMax } from 'gsap';
import Dragdealer from 'dragdealer';

export default function initGsapSlider() {

  addPolyfillClosest();

  let tl = new TimelineLite({paused: true}),
      back = document.querySelector('.partners-back'),
      front = document.querySelector('.partners-front'),
      backChilds = Array.from(back.querySelectorAll('.item.mix')),
      frontChilds = Array.from(front.querySelectorAll('.item')),
      frontSlide = document.querySelector('.sec4 .partners-slider'),
      backTitle = document.querySelector('.partners-back .section__title'),
      frontTitle = front.querySelector('.go_back'),
      frontPagination = front.querySelector('.content-scroller'),
      prevProjectBtn = front.querySelector('.project-nav.left'),
      nextProjectBtn = front.querySelector('.project-nav.right'),
      index, prevIndex, dragD;

      tl.to(backChilds, 0.5, { yPercent: -10, autoAlpha: 0, ease: Power1.easeOut})
        .set(frontChilds, {clearProps: 'all'})
        .set(front, { zIndex: 1, position: 'static'})
        .set(back, {visibility: 'hidden', position: 'absolute'})
        // .from(frontTitle, 1, { y: 68, ease: Power1.easeOut})
        .set(frontTitle, { className: '-=hide-arrow'})
        .from(frontSlide, 0.5, { yPercent: 10, autoAlpha: 0, ease: Power1.easeOut})

  back.addEventListener('click', (event) => {
    event.preventDefault();
    let selected = event.target.closest('.item.mix');
    if(!selected) {
      console.log('not a tag!');
      return;
    }

    index = backChilds.indexOf(selected);
    console.log(index, frontChilds.length,  frontChilds[index]);
    // if(prevIndex || prevIndex === 0) {
    //     frontChilds[prevIndex].classList.remove('active');
    // }
    // console.log(prevIndex);
    frontChilds.forEach((x) => {
      x.classList.remove('active');
    });

    // navs text change
    changeNavText(index + 1, nextProjectBtn);
    changeNavText(index - 1, prevProjectBtn);

    frontChilds[index].classList.add('active');

    if(window.innerWidth > 767) {
      let fl = frontChilds.length;
      let fle = 1 / fl;

      dragD = new Dragdealer(frontPagination, {
        x: index * fle,
        steps: 0,
        dragStopCallback: function(x, y) {
          let ind = Math.floor(x / fle);
          // alert('drag end');

          if(ind === fl) {
            return;
          }

          frontChilds.forEach((x) => {
            x.classList.remove('active');
          });

          frontChilds[ind].classList.add('active');

          changeNavText(ind - 1, prevProjectBtn);
          changeNavText(ind + 1, nextProjectBtn);

          prevIndex = ind;
          // alert(prevIndex);
        }
      });
    }

    tl.play();

    prevIndex = index;

  });

  let fl2 = frontChilds.length;
  let fle2 = 1 / fl2;

  frontTitle.addEventListener('click', (e) => {
    tl.reverse();
    prevIndex = index;
    e.preventDefault()
  });

  nextProjectBtn.addEventListener('click', (e) => {
    e.preventDefault();
    nextSlide();
  });

  if(window.innerWidth > 767) {
    prevProjectBtn.addEventListener('click', (e) => {
      e.preventDefault();
      prevSlide();
    });
  } else {
    let baseX;
    front.addEventListener('touchstart', e => {
      console.log(e);
      baseX = e.touches[0].clientX;
    })
    front.addEventListener('touchend', (e) => {
      let newX = e.changedTouches[0].clientX;
      if(newX - baseX > 15) {
        prevSlide();
        // alert('prev');
      } else if(newX - baseX < -15) {
        nextSlide();
        // alert('next');
      }
    })
  }




  function nextSlide() {

    let prev = index,
        current = prevIndex + 1;

    if(current >= frontChilds.length ||
      TweenMax.isTweening(frontChilds[prevIndex]) ||
      TweenMax.isTweening(frontChilds[current])) {
      console.log(current, frontChilds.length);
      return;
    }

    let tl_next = new TimelineLite();

    changeNavText(current + 1, nextProjectBtn);
    changeNavText(current - 1, prevProjectBtn);

    // alert(prevIndex);

    tl_next
      .to(frontChilds[prevIndex], 0.5, {x: -150, autoAlpha: 0, ease: Power1.easeOut})
      .set(frontChilds[prevIndex], {className: '-=active', clearProps: 'all'})
      .set(frontChilds[current], {display: 'block'})
      .fromTo(frontChilds[current], 1, {x: 150, autoAlpha: 0, ease: Power1.easeOut}, {x: 0, autoAlpha: 1, ease: Power1.easeOut})
      .set(frontChilds[current], {className: '+=active', clearProps: 'all'});


    if(window.innerWidth > 767) {
      dragD.setValue(current * fle2, 0);
    }

    prevIndex = current;

    index++;
  }

  function prevSlide() {

    let next = index,
        current = prevIndex - 1;

    console.log(index);

    if(index <= 0 ||
      TweenMax.isTweening(frontChilds[prevIndex]) ||
      TweenMax.isTweening(frontChilds[current])) {
      return;
    }

    let tl_prev = new TimelineLite();

    changeNavText(current - 1, prevProjectBtn);
    changeNavText(current + 1, nextProjectBtn);

    tl_prev
      .to(frontChilds[prevIndex], 0.5, {x: 150, autoAlpha: 0, ease: Power1.easeOut})
      .set(frontChilds[prevIndex], {className: '-=active', clearProps: 'all'})
      .set(frontChilds[current], {display: 'block'})
      .fromTo(frontChilds[current], 1, {x: -150, autoAlpha: 0, ease: Power1.easeOut,}, {x: 0, autoAlpha: 1, ease: Power1.easeOut})
      .set(frontChilds[current], {className: '+=active', clearProps: 'all'});

    if(window.innerWidth > 767) {
      dragD.setValue(current * fle2, 0);
    }

    prevIndex = current;

    index--;
  }

  function changeNavText(index, nav) {
    let slide = frontChilds[index];
    if(!slide) {
      nav.classList.add('empty');
    } else {
      nav.classList.remove('empty');
      let nextText = slide.querySelector('.slide-title').textContent;
      nav.textContent = nextText;
    }
  }


}


function addPolyfillClosest() {
  if (window.Element && !Element.prototype.closest) {
      Element.prototype.closest =
      function(s) {
          var matches = (this.document || this.ownerDocument).querySelectorAll(s),
              i,
              el = this;
          do {
              i = matches.length;
              while (--i >= 0 && matches.item(i) !== el) {};
          } while ((i < 0) && (el = el.parentElement));
          return el;
      };
  }
}



// WEBPACK FOOTER //
// ./src/js/gsap-slider.js